module.exports = __webpack_public_path__ + "static/img/wenda_icon.507091f0.png";